import { render, staticRenderFns } from "./PremioAccordion.vue?vue&type=template&id=0ea2374a"
import script from "./PremioAccordion.vue?vue&type=script&lang=js"
export * from "./PremioAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports